export default __webpack_public_path__ + "static/media/main_level_test02_en.85e5dbcf.png";